import React from 'react';

import styles from './styles.module.css';

/**
 * Props for the ProgressBar component
 */
type ProgressBarProps = {
  /** The value of the progress bar (0 to 1) */
  value: number;
  /** Optional label to display alongside the progress bar */
  label?: string;
  /** Color variant for the progress bar */
  color?:
    | 'primary'
    | 'secondary'
    | 'danger'
    | 'success'
    | 'warning'
    | 'info'
    | 'light'
    | 'dark'
    | undefined;
};

/**
 * ProgressBar component displays a progress bar with a specified value and color.
 */
const ProgressBar: React.FC<ProgressBarProps> = ({
  label,
  value,
  color = 'success',
}) => {
  // Convert value to percentage
  const valueInPercent = value * 100;

  // Determine the background color class based on the specified color prop
  const bgClass = `bg-${color}`;

  // Function to determine the text color class based on the specified color prop
  const getTextClass = () => {
    switch (color) {
      case 'primary':
      case 'secondary':
      case 'warning':
      case 'dark':
        return 'text-light'; // Light text color for dark backgrounds
      case 'danger':
      case 'success':
      case 'light':
      case 'info':
      default:
        return 'text-dark'; // Dark text color for light backgrounds
    }
  };

  const textContent = `${
    label ? label : valueInPercent.toLocaleString() + ' %'
  }`;

  return (
    <div className={styles.progressBar}>
      {/* Value display */}

      {/* Progress bar */}
      <div
        className={`${bgClass} ${styles.bar}`}
        style={{ maxWidth: `${valueInPercent}%` }}
      >
        <span style={{ display: 'none' }}>{textContent}</span>
      </div>
      <div className={`${styles.value} text-nowrap`}>{textContent}</div>
    </div>
  );
};

export default ProgressBar;
